// https://github.com/Microsoft/TypeScript/issues/12756#issuecomment-265812676

import * as React from 'react';
import * as Contentful from 'contentful'
import { ContentfulClientApi } from 'contentful'
import { omit } from 'lodash' 

export type Wrapped<P> = React.ComponentClass<P> | React.StatelessComponent<P>;


export interface HOCProps {
    count:number,
    duration:number
}

export interface PartialHocProps{
   duration:number
}

interface State{
    count:number,
    handler:any
}


export default function <P extends PartialHocProps>(Component: React.ComponentClass<P & HOCProps>): React.ComponentClass< P | PartialHocProps > {

    return class extends React.Component<P, State> {

        componentWillMount(){
            this.setState({
                count: 0,
                handler: setInterval((_) => {
                    this.setState({
                        ...this.state,
                        count: this.state.count + 1
                    })
                }, this.props.duration)
            })
        }


        componentWillUnmount(){
            clearInterval(this.state.handler)
        }


        public render() {
            const childProps = omit(this.props, "count");

            return (
                <Component count={ this.state.count } {...childProps} />
            );
        }

    }

}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/high-order/with-interval.tsx